import { mapImageConstants } from '../utils/imageMapper';
import insightsData from '../data/insightsData.json';

export interface BlogPost {
  id: string;
  image: string;
  title: string;
  excerpt: string;
  readMore: string[];
  fullDescription: string | string[];
}

export interface EventPost {
  id: string;
  image: string;
  title: string;
  titlePosition: string;
  excerpt: string;
  content?: Array<{
    image: string[];
    description: string;
    imagePosition?: 'left' | 'right';
  }>;
}

export interface NewsPost {
  id: string;
  image: string;
  title: string;
  excerpt: string;
  content?: Array<{
    image: string[];
    title: string;
    titleStyle?: string;
    description: string;
    videos?: string[];
    viewPostUrl?: string | string[];
  }>;
}

export interface InsightsData {
  heroSection: {
    title: string;
    description: string;
    images: {
      clouds: string;
      rocket: string;
    };
    sectionTitle: string;
  };
  blogPosts: BlogPost[];
  eventsPosts: EventPost[];
  newsPosts: NewsPost[];
}

export function useInsightsData() {
  const data = mapImageConstants(insightsData as InsightsData);
  const loading = false;
  const error = null;

  return { data, loading, error };
}
